function getSharedKey() {
  return (
    process.env.VUE_APP_API_CRYPTO_KEY || 'aquidauana-dev-crypto-key-heber'
  )
}

function resolveSecret(response) {
  const useBearer =
    String(process.env.VUE_APP_API_CRYPTO_USE_BEARER || '').toLowerCase() ===
    'true'
  if (useBearer) {
    const headers =
      response.config && response.config.headers
        ? response.config.headers
        : {}
    const auth = headers.Authorization || headers.authorization || ''
    const match = String(auth).match(/^Bearer\s+(.+)$/i)
    if (match && match[1]) {
      return match[1]
    }
  }
  return getSharedKey()
}

async function sha256Binary(secret) {
  const data = new TextEncoder().encode(secret)
  return crypto.subtle.digest('SHA-256', data)
}

function base64ToBytes(value) {
  const binary = atob(value)
  const bytes = new Uint8Array(binary.length)
  for (let i = 0; i < binary.length; i += 1) {
    bytes[i] = binary.charCodeAt(i)
  }
  return bytes
}

function parseCompactString(value) {
  if (typeof value !== 'string') {
    return null
  }
  const parts = value.split('.')
  if (parts.length !== 3 || !parts[0] || !parts[1] || !parts[2]) {
    return null
  }
  return { iv: parts[0], payload: parts[1], tag: parts[2] }
}

function normalizeEnvelope(data) {
  if (typeof data === 'string') {
    return parseCompactString(data)
  }
  if (
    data &&
    typeof data === 'object' &&
    data.payload &&
    data.iv &&
    data.tag
  ) {
    return data
  }
  return null
}

function isEncryptedEnvelope(data, response) {
  const header =
    response.headers &&
    (response.headers['x-api-crypto'] || response.headers['X-Api-Crypto'])
  if (String(header) === '1') {
    return normalizeEnvelope(data) !== null || typeof data === 'string'
  }
  return normalizeEnvelope(data) !== null
}

export async function decryptApiPayload(envelopeOrString, secret) {
  const envelope = normalizeEnvelope(envelopeOrString)
  if (!envelope) {
    throw new Error('Invalid crypto envelope')
  }

  const keyMaterial = await sha256Binary(secret)
  const key = await crypto.subtle.importKey(
    'raw',
    keyMaterial,
    { name: 'AES-GCM' },
    false,
    ['decrypt']
  )

  const iv = base64ToBytes(envelope.iv)
  const tag = base64ToBytes(envelope.tag)
  const payload = base64ToBytes(envelope.payload)
  const cipherWithTag = new Uint8Array(payload.length + tag.length)
  cipherWithTag.set(payload)
  cipherWithTag.set(tag, payload.length)

  const plainBuffer = await crypto.subtle.decrypt(
    { name: 'AES-GCM', iv },
    key,
    cipherWithTag
  )

  return JSON.parse(new TextDecoder().decode(plainBuffer))
}

export function installAxiosCryptoInterceptor(axiosInstance) {
  axiosInstance.interceptors.response.use(
    async (response) => {
      const data = response.data
      if (isEncryptedEnvelope(data, response)) {
        try {
          response.data = await decryptApiPayload(
            data,
            resolveSecret(response)
          )
        } catch (error) {
          return Promise.reject(error)
        }
      }
      return response
    },
    (error) => Promise.reject(error)
  )
}
